"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeFiPaymentId = exports.encodeFiPaymentId = exports.luhnChecksum = exports.clone = exports.sortBySameCategoryDateDescFirst = exports.sortByWithExtraDiscriminator = exports.sortBy = exports.bottleneck = void 0;
const bottleneck_1 = __importDefault(require("bottleneck"));
const bns = {};
const bottleneck = (handle, minTime, f, concurrent) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((res, rej) => {
        if (!bns[handle]) {
            bns[handle] = new bottleneck_1.default({
                maxConcurrent: concurrent,
                minTime: minTime,
            });
        }
        bns[handle].schedule(f).then(res).catch(rej);
    });
});
exports.bottleneck = bottleneck;
const sortBy = (...compareFunctions) => (a, b) => {
    if (compareFunctions.length === 0) {
        return 0;
    }
    for (let i = 0; i < compareFunctions.length; i++) {
        const result = compareFunctions[i](a, b);
        if (result !== 0) {
            return result;
        }
    }
    return 0;
};
exports.sortBy = sortBy;
const sortByWithExtraDiscriminator = (...compareFunctions) => (a, b, c) => {
    if (compareFunctions.length === 0) {
        return 0;
    }
    for (let i = 0; i < compareFunctions.length; i++) {
        const result = compareFunctions[i](a, b, c);
        if (result !== 0) {
            return result;
        }
    }
    return 0;
};
exports.sortByWithExtraDiscriminator = sortByWithExtraDiscriminator;
const sortBySameCategoryDateDescFirst = (a, b, voucherBeingAppended) => {
    const aSameCategory = a.category === voucherBeingAppended.category;
    const bSameCategory = b.category === voucherBeingAppended.category;
    if (aSameCategory && bSameCategory)
        return new Date(b.date).getTime() - new Date(a.date).getTime();
    if (aSameCategory)
        return -1;
    if (bSameCategory)
        return 1;
    return 0;
};
exports.sortBySameCategoryDateDescFirst = sortBySameCategoryDateDescFirst;
const clone = (o) => JSON.parse(JSON.stringify(o));
exports.clone = clone;
const luhnChecksum = (code) => {
    const len = code.length;
    const parity = len % 2;
    let sum = 0;
    for (let i = len - 1; i >= 0; i--) {
        let d = parseInt(code.charAt(i));
        if (i % 2 == parity) {
            d *= 2;
        }
        if (d > 9) {
            d -= 9;
        }
        sum += d;
    }
    return sum % 10;
};
exports.luhnChecksum = luhnChecksum;
const encodeFiPaymentId = (partcode) => {
    const pcode = partcode.toString();
    let checksum = (0, exports.luhnChecksum)(pcode + '0');
    checksum = checksum == 0 ? 0 : 10 - checksum;
    let digit = pcode + checksum;
    while (digit.length < 15) {
        digit = '0' + digit;
    }
    return digit;
};
exports.encodeFiPaymentId = encodeFiPaymentId;
const decodeFiPaymentId = (s) => {
    const n = parseInt(s.slice(0, -1));
    if (s.slice(-1) !== (0, exports.encodeFiPaymentId)(n).slice(-1)) {
        throw new Error('Error in payment ID');
    }
    return n;
};
exports.decodeFiPaymentId = decodeFiPaymentId;
//# sourceMappingURL=utils.js.map